import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import {
  AddError,
  LoadSpecificDiagnosis,
  PushNotification,
  UpdateDiagonsis,
  UpdateUser,
} from '../../DB/DB';
import { useDocContext } from '../../context/DocContext';
import Cookies from 'js-cookie';
import axios from 'axios';
import Head from 'next/head';
import randomatic from 'randomatic';
import { toast } from 'react-toastify';
import DiagnosisProgression from '../../components/Diagnosis/medical/DiagnosisProgression';

import DialogBox from '../../components/dialogBox';

import SwipeableViews from 'react-swipeable-views';
import CheckoutPackageSelector, {
  ArrowBackward,
} from '../../components/Diagnosis/checkout/CheckoutPackageSelector';
import CheckoutAgreement from '../../components/Diagnosis/checkout/CheckoutAgreement';
import { tokenizeCard } from '../../utils/tokenizeCard';
import { track } from '../../utils/funnelTracking';
import { VIEW_KEYS, EVENT_TYPES } from '../../utils/funnelConstants';

const PaymentConfirmation = () => {
  const [modalShow, setModalShow] = useState(false);
  const router = useRouter();
  const swipeableRef = useRef(null);
  const containerRef = useRef();
  const [currentStep, setCurrentStep] = useState(0);
  const [pricePackage, setPricePackage] = useState(0);

  const [treatmentPrice, setTreatmentPrice] = useState(40.0);
  const [errorTime, setErrorTime] = useState(null);
  const { user, setContext, hasSubscription } = useDocContext();

  // Subscription test: reached checkout.
  useEffect(() => {
    track(VIEW_KEYS.SUB_CHECKOUT, EVENT_TYPES.VIEWED);
  }, []);
  const [diagnosis, setDiagnosis] = useState(null);
  const [diseaseData, setdiseaseData] = useState();
  const [paymentLoading, setpaymentLoading] = useState(false);

  const [cardNumber, setCardNumber] = useState('');
  const [agreeToTerm, setAgreeToTerm] = useState(false);
  const [cvv, setCvv] = useState('');
  const [cardName, setCardName] = useState('');
  const [billingAddress, setBillingAddress] = useState('');
  const [zipCode, setZipCode] = useState('');

  const [cardError, setCardError] = useState('');
  const [expMonthError, setExpMonthError] = useState('');
  const [expYearError, setExpYearError] = useState('');
  const [cvvError, setCvvError] = useState('');
  const [cardNameError, setCardNameError] = useState('');

  const [expiryDate, setExpiryDate] = useState('');
  const [expiryError, setExpiryError] = useState('');

  const [isCouponValid, setisCouponValid] = useState(false);

  useEffect(() => {
    if (user && hasSubscription == false) {
      setCurrentStep(0);
    } else if (user && hasSubscription) {
      setCurrentStep(2);
    }
  }, [user, hasSubscription]);

  const formatCardNumber = (input) => {
    return input
      .replace(/\D/g, '') // Remove non-numeric characters
      .replace(/(.{4})/g, '$1 ') // Add space after every 4 digits
      .trim(); // Remove trailing space
  };

  const handleCardNumberChange = (value) => {
    const formattedValue = formatCardNumber(value);
    setCardNumber(formattedValue);
  };
  const validateCardNumber = () => {
    if (
      cardNumber.replace(/\s/g, '').length < 13 ||
      cardNumber.replace(/\s/g, '').length > 19
    ) {
      setCardError('Credit card number must be between 13 and 19 digits.');
    } else {
      setCardError('');
    }
  };

  // Format MM/YY while typing
  const formatExpiryDate = (input) => {
    return input
      .replace(/\D/g, '') // Remove non-numeric characters
      .replace(/^(0[1-9]|1[0-2])(\d{0,2})$/, '$1/$2') // Format MM/YY
      .substring(0, 5); // Ensure max length is 5 (MM/YY)
  };

  const handleExpiryChange = (e) => {
    const formattedValue = formatExpiryDate(e.target.value);
    setExpiryDate(formattedValue);
  };

  const validateExpiryDate = () => {
    if (!/^(0[1-9]|1[0-2])\/\d{2}$/.test(expiryDate)) {
      setExpiryError('Enter a valid expiry date (MM/YY)');
    } else {
      setExpiryError('');
    }
  };
  const validateCvv = () => {
    if (cvv.length < 3 || cvv.length > 4) {
      setCvvError('CVV must be 3 or 4 digits.');
    } else {
      setCvvError('');
    }
  };

  const validateCardName = () => {
    if (cardName.trim() === '') {
      setCardNameError('Name on card cannot be empty.');
    } else {
      setCardNameError('');
    }
  };

  async function sendReceipt(brandedCoupon = null) {
    await axios.post('/api/sendReceipt', {
      email: user.email,
      name: user.name,
      dName: diagnosis.servicename,
      amount: treatmentPrice.toFixed(2),
      diagnosisID: diagnosis.objectId || new Date().toISOString(),
      //Checking if the disease is an STD and if the coupon is not valid, because we only want to send coupon
      //  if it's not the 50% partner using the coupon code, because if iscouponvalid is true then it's the partner using the coupon
      isSTD:
        (std_list.includes(diseaseData?.objectId) ||
          diseaseData?.category?.objectId === 'YAhR6Nfm4U') &&
        isCouponValid == false,
      couponCode: brandedCoupon,
    });
  }

  const submitCardDetails = async (e) => {
    e.preventDefault();
    if (paymentLoading) return; // 🔒 prevents re-entry
    if (hasSubscription == true) {
      toast.info('You already have an active subscription.');
      return;
    }
    validateCardNumber();

    validateCvv();
    validateCardName();
    validateExpiryDate();
    if (
      cardError ||
      expMonthError ||
      expYearError ||
      cvvError ||
      cardNameError
    ) {
      return;
    }
    if (agreeToTerm == false) {
      toast.error('Must agree to our terms before proceeding further');
      return;
    }

    // Handle form submission here
    const paymentDetails = {
      cardNumber,
      expiryDate,
      cvv,
      cardName,
      billingAddress,
      zipCode,
    };
    try {
      setpaymentLoading(true);

      let response;
      const [mm = '', yy = ''] = paymentDetails.expiryDate.split('/');
      const opaqueData = await tokenizeCard({
        cardNumber: paymentDetails.cardNumber,
        month: mm,
        year: yy,
        cvv: paymentDetails.cvv,
        zip: paymentDetails.zipCode,
      });
      if (pricePackage == 0) {
        response = await axios.post('/api/authorize/charge-accept', {
          opaqueData: opaqueData,
          amount: calculatePrice(),

          userID: user.objectId,
          diagnosisID: 'subscription',
          diseaseTitle: 'subscription',
          email: user.email,
          cardName: paymentDetails.cardName,
          billingAddress: paymentDetails.billingAddress,
          zipCode: paymentDetails.zipCode,
        });
      } else {
        response = await axios.post('/api/authorize/subscribe-accept', {
          opaqueData: opaqueData,
          amount: 40,
          userID: user?.objectId,
          email: user?.email,
          firstName: user?.first_name,
          lastName: user?.last_name,
          billingAddress: paymentDetails.billingAddress,
          zipCode: paymentDetails.zipCode,
          sessionToken: Cookies.get('sessionToken'),
          invoiceNumber: `PSUB-${user.objectId}`, // Invoice number
        });
      }

      if (response.status == 200) {
        //checking if the user has a partner treatment

        setpaymentLoading(false);
        // Subscription test: payment approved. track() never throws, so it
        // can't strand a patient whose card was already charged.
        track(VIEW_KEYS.SUB_CHECKOUT_SUCCESS, EVENT_TYPES.COMPLETED, {
          userId: user?.objectId ?? null,
          note: pricePackage == 1 ? 'subscription' : 'one_time',
        });
        fireBuyEvent();
        if (window.uetq) {
          window.uetq.push('event', 'purchase', {
            revenue_value: treatmentPrice,
            currency: 'USD',
          });
        }

        toast.success('Payment Successfull');
        if (pricePackage == 1) {
          toast.success('Subscription created');
        }
        toast('Please wait');
        setModalShow(true);

        setContext((context) => {
          return { ...context, hasNotifications: true };
        });

        await PushNotification(6, user?.objectId);

        await sendReceipt();

        const delay = (ms) => new Promise((res) => setTimeout(res, ms));
        await delay(1500);
        window.location.href = '/services';
      }
    } catch (err) {
      if (errorTime == null) {
        setErrorTime(new Date());
      } else {
        if (
          new Date() - errorTime > 60000 / 4 &&
          err.response &&
          err.response.status >= 500 &&
          err.response.status < 600
        ) {
          AddError(
            {
              error: err?.message,
              url: err?.config?.url,
              stack: err?.stack,
              response: err?.response?.data,
            },
            user.objectId,
            diagnosis.objectId,
            'payment-confirmation',
            {}
          );
        }
        setErrorTime(new Date());
      }
      setpaymentLoading(false);

      if (err?.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (err?.response?.status == 409)
          toast.warning(err?.response?.data?.message);
        console.log('Error response status:', err?.response?.status);
        console.log('Error response headers:', err?.response?.headers);
      } else if (err?.request) {
        // The request was made but no response was received
        console.log('Error request:', err?.request);
        toast.warning('No response, please try again.');
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error message:', err?.message);
      }
      console.log('Error config:', err?.config);
      toast.error(err?.response?.data?.text);
    }
  };

  function fireBuyEvent() {
    if (!window.dataLayer) return;
    window.dataLayer.push({
      event: 'purchase',
      ecommerce: {
        transaction_id: randomatic('0', 5),
        value: 40,
        currency: 'USD',
        items: [
          {
            item_id: 'subscription_001',
            item_name: 'Subscription',
            currency: 'USD',
            price: 40,
            quantity: 1,
          },
        ],
      },
    });
  }
  function updateHeight(e) {
    swipeableRef.current = e;
  }
  function changeIndex(index) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
  return (
    <div className='d-flex flex-column flex-grow-1'>
      <Head>
        <meta name='robots' content='noindex,nofollow' />
      </Head>

      <DialogBox
        variant='success'
        modalShow={modalShow}
        setModalShow={setModalShow}
      >
        Please wait while we process your consultation form!
      </DialogBox>
      <DiagnosisProgression
        TOTALSCREENS={1}
        current_step='Checkout'
        currentScreen={1}
      />

      {hasSubscription == undefined ? (
        <div className=' tw-h-svh tw-w-svw tw-grid tw-place-items-center'>
          <Spinner className=' tw-w-16 tw-h-16 tw-text-[#1f56df] tw-font-semibold' />
        </div>
      ) : (
        <div className=' tw-flex-1 tw-bg-[#F5F2F1]'>
          <SwipeableViews
            index={currentStep}
            animateHeight
            action={updateHeight}
            ref={containerRef}
            disabled={true}
            onTransitionEnd={changeIndex}
          >
            <CheckoutPackageSelector
              diagnosis={diagnosis}
              setCurrentStep={setCurrentStep}
              setPricePackage={setPricePackage}
              pricePackage={pricePackage}
              isSubscribing={true}
            />
            <CheckoutAgreement setCurrentStep={setCurrentStep} />
            <div className='flex-grow-1' style={{ backgroundColor: '#f5f2f1' }}>
              <div className='containerCheckout'>
                <h2 className='flowHeading text-start'>
                  Almost done,{' '}
                  <span className=' gradientText'>last details</span>
                </h2>
                <div className='checkoutCart'>
                  {/* <img
                    src={diseaseData?.thumbnail}
                    alt='disease thumbnail'
                    width={74}
                    height={74}
                  /> */}
                  <div className='treatment'>
                    <div>
                      <h3>{diseaseData?.title} Subscription</h3>
                      <div className=' tw-flex tw-items-center tw-mb-2'>
                        {' '}
                        <p
                          className={`price tw-mb-0 ${
                            isCouponValid ? ' tw-line-through' : ''
                          }`}
                        >
                          <span>$ 40</span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <span className='checkoutLogo'>
                    <CheckLogo />
                  </span>
                </div>
                <p
                  style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    marginBottom: 0,
                  }}
                >
                  Payment details
                </p>
                <hr
                  className=' my-3'
                  style={{ color: 'rgba(96, 96, 96, 0.5)' }}
                />
                <Form
                  onSubmit={submitCardDetails}
                  style={{ display: 'flex', flexDirection: 'column' }}
                  className='profile-form'
                >
                  <Form.Group as={Row} className='mb-2 gx-0 mt-2'>
                    <Form.Label className='flowQuestionLabel'>
                      Credit card number
                    </Form.Label>
                    <Form.Control
                      type='text'
                      name='cc-number'
                      autoComplete='cc-number'
                      required
                      value={cardNumber}
                      onChange={(e) => handleCardNumberChange(e.target.value)}
                      onBlur={validateCardNumber}
                      isInvalid={!!cardError}
                      className='flowQuestionTextInput'
                    />
                    <Form.Control.Feedback type='invalid'>
                      {cardError ? cardError : null}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Row} className='mb-2 gx-6'>
                    <Col xs={6}>
                      <Form.Label className='flowQuestionLabel'>
                        Expiry Date
                      </Form.Label>
                      <Form.Control
                        type='text'
                        name='expiry-date'
                        placeholder='MM/YY'
                        value={expiryDate}
                        onChange={handleExpiryChange}
                        onBlur={validateExpiryDate}
                        isInvalid={!!expiryError}
                        maxLength={5} // 4 digits + 1 slash
                        className='flowQuestionTextInput'
                      />
                      <Form.Control.Feedback type='invalid'>
                        {expiryError}
                      </Form.Control.Feedback>
                    </Col>
                    <Col xs={6}>
                      <Form.Label className='flowQuestionLabel'>
                        Security code
                      </Form.Label>
                      <Form.Control
                        type='text'
                        name='security-code'
                        placeholder='CVC'
                        value={cvv}
                        onChange={(e) => setCvv(e.target.value)}
                        onBlur={validateCvv}
                        isInvalid={!!cvvError}
                        maxLength={4}
                        className='flowQuestionTextInput'
                      />
                      <Form.Control.Feedback type='invalid'>
                        {cvvError}
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                  <hr
                    className=' my-3'
                    style={{ color: 'rgba(96, 96, 96, 0.5)' }}
                  />
                  <Form.Group as={Row} className='mb-2 gx-0'>
                    <Form.Label className='flowQuestionLabel'>
                      Name appearing on debit card
                    </Form.Label>
                    <Form.Control
                      type='text'
                      name='cc-name'
                      autoComplete='cc-name'
                      required
                      value={cardName}
                      onChange={(e) => setCardName(e.target.value)}
                      onBlur={validateCardName}
                      isInvalid={!!cardNameError}
                      className='flowQuestionTextInput'
                    />
                    <Form.Control.Feedback type='invalid'>
                      {cardName && cardName.trim() === ''
                        ? cardNameError
                        : null}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Row} className='mb-2 gx-6'>
                    <Col xs={6}>
                      {' '}
                      <Form.Label className='flowQuestionLabel'>
                        Billing address
                      </Form.Label>
                      <Form.Control
                        type='text'
                        name='billing-address'
                        autoComplete='billing address-line1'
                        required
                        value={billingAddress}
                        onChange={(e) => setBillingAddress(e.target.value)}
                        className='flowQuestionTextInput'
                      />
                    </Col>
                    <Col xs={6}>
                      <Form.Label className='flowQuestionLabel'>
                        Zip code
                      </Form.Label>
                      <Form.Control
                        type='number'
                        name='postal-code'
                        autoComplete='postal-code'
                        required
                        value={zipCode}
                        onChange={(e) => setZipCode(e.target.value)}
                        className='flowQuestionTextInput'
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group className=' d-flex align-items-start my-4'>
                    <Form.Check
                      size='sm'
                      style={{ marginTop: 0, marginRight: 8 }}
                      id='IAgree'
                      value={agreeToTerm}
                      onChange={(e) => {
                        setAgreeToTerm((agreeToTerm) =>
                          setAgreeToTerm(!agreeToTerm)
                        );
                      }}
                    />
                    <Form.Label
                      className='flowQuestionLabel'
                      htmlFor='IAgree'
                      style={{ fontSize: 12, lineHeight: 1.5 }}
                    >
                      I certify that the information I provided is complete,
                      accurate and up-to-date to the best of my knowledge. I
                      understand that incomplete, inaccurate and false
                      information puts me at a harmful risk of misdiagnosis and
                      inappropriate treatment.
                    </Form.Label>
                  </Form.Group>
                  <div className=' tw-flex tw-flex-col tw-space-y-4'></div>
                  <button
                    type='submit'
                    className='btnWelcome d-flex justify-content-center'
                  >
                    {paymentLoading && (
                      <Spinner
                        color='#43cba2'
                        style={{ marginRight: '1rem' }}
                      />
                    )}
                    Pay
                  </button>
                  {hasSubscription ? null : (
                    <button
                      onClick={() =>
                        pricePackage == 0
                          ? setCurrentStep(0)
                          : setCurrentStep(1)
                      }
                      type='button'
                      className=' tw-flex tw-items-center tw-justify-center tw-w-full tw-border-0 tw-bg-white tw-py-3 tw-rounded-full tw-mt-4 tw-text-sm'
                    >
                      <span className=' tw-mr-2'>
                        <ArrowBackward />
                      </span>
                      Back
                    </button>
                  )}
                </Form>
              </div>
            </div>
          </SwipeableViews>
        </div>
      )}
    </div>
  );
};

export default PaymentConfirmation;

export async function getServerSideProps(context) {
  return { props: { layout: 'no-layout' } };
}
const CheckLogo = () => (
  <svg
    width='53'
    height='53'
    viewBox='0 0 53 53'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_3073_51136)'>
      <rect
        x='17.5234'
        y='16.4062'
        width='23'
        height='16'
        transform='rotate(9.36628 17.5234 16.4062)'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M46.1868 31.93C46.2897 31.5569 46.2399 31.1552 46.0466 30.8208L44.328 27.8002L46.4667 25.0578C46.7067 24.7538 46.8129 24.3682 46.7639 23.9801C46.7178 23.5972 46.5196 23.2481 46.2103 23.0112L43.4668 20.8766L44.3943 17.5283C44.4983 17.1511 44.4474 16.7534 44.2594 16.4161C44.066 16.0818 43.7508 15.8343 43.3735 15.7303L40.0229 14.811L39.5956 11.3613C39.5507 10.9743 39.3526 10.6252 39.0473 10.3895C38.7392 10.1484 38.3536 10.0421 37.9696 10.0924L34.5187 10.5237L32.8054 7.50003C32.6174 7.16271 32.2979 6.91404 31.9248 6.81119C31.5517 6.70834 31.1499 6.75815 30.8156 6.95148L27.7949 8.67005L25.0526 6.53132C24.7486 6.29135 24.363 6.18505 23.9749 6.23421C23.5919 6.28024 23.2429 6.47845 23.006 6.78779L20.8714 9.53124L17.5231 8.60369C17.1458 8.49968 16.7483 8.55067 16.4109 8.73863C16.0766 8.93197 15.8291 9.24734 15.7251 9.62457L14.8058 12.9751L11.3561 13.4023C10.9691 13.4473 10.62 13.6455 10.3842 13.9507C10.1432 14.2589 10.0369 14.6444 10.0871 15.0285L10.5185 18.4794L7.4948 20.1926C7.15747 20.3807 6.90885 20.7002 6.80599 21.0733C6.70314 21.4463 6.75292 21.8481 6.94625 22.1824L8.66481 25.2031L6.5261 27.9454C6.28616 28.2495 6.17987 28.635 6.22896 29.0232C6.275 29.4061 6.47321 29.7552 6.78251 29.9921L9.526 32.1267L8.59849 35.475C8.4945 35.8522 8.54541 36.2499 8.73342 36.5871C8.92682 36.9215 9.24207 37.1689 9.61933 37.273L12.9699 38.1922L13.3972 41.6419C13.4421 42.029 13.6403 42.378 13.9455 42.6138C14.2536 42.8549 14.6392 42.9612 15.0232 42.9109L18.4741 42.4796L20.1874 45.5033C20.3754 45.8405 20.695 46.0892 21.068 46.1921C21.4411 46.2949 21.8429 46.2451 22.1772 46.0518L25.1979 44.3332L27.9402 46.472C28.2443 46.7119 28.6298 46.8182 29.0179 46.7691C29.4009 46.723 29.7499 46.5248 29.9868 46.2155L32.1214 43.472L35.4698 44.3996C35.847 44.5036 36.2446 44.4526 36.582 44.2646C36.9162 44.0713 37.1637 43.7559 37.2677 43.3787L38.187 40.0281L41.6367 39.6009C42.0238 39.5559 42.3728 39.3578 42.6086 39.0525C42.8497 38.7444 42.9559 38.3588 42.9057 37.9747L42.4743 34.5239L45.498 32.8106C45.8353 32.6226 46.084 32.3031 46.1868 31.93ZM19.2917 26.1274C18.695 25.0763 19.0667 23.7279 20.1178 23.1311C21.1689 22.5343 22.5111 22.9043 23.1141 23.9571L24.9317 27.1584L31.6161 21.9889C32.5734 21.2453 33.9546 21.4246 34.6982 22.3819C35.4418 23.3391 35.2626 24.7204 34.3052 25.464L25.6153 32.1829C25.111 32.5745 24.4587 32.7238 23.8349 32.5988C23.2111 32.4739 22.6737 32.0839 22.3573 31.5265L19.2917 26.1274Z'
        fill='url(#paint0_linear_3073_51136)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_3073_51136'
        x1='31.9248'
        y1='6.81119'
        x2='21.068'
        y2='46.1921'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#3FC1A2' />
        <stop offset='1' stop-color='#1C7B65' />
      </linearGradient>
      <clipPath id='clip0_3073_51136'>
        <rect
          width='43'
          height='43'
          fill='white'
          transform='translate(11.4844 0.0625) rotate(15.4128)'
        />
      </clipPath>
    </defs>
  </svg>
);
